module.exports = __webpack_public_path__ + "static/media/Subscription.ace339f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/Subscription.svg
// module id = 1368
// module chunks = 0